import api from "~/services/apis/antecipeApi";

export const listDomains = async () => (await api.get("antecipeadmin/domains")).data.data;
export const addDomain = async (domain) => (await api.post("antecipeadmin/domains", { domain })).data.data;
export const removeDomain = async (id) => {
  await api.delete(`antecipeadmin/domains/${id}`);
};
